import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@urc-ui/store/api/base';
import { HttpMethod, Tag } from '@urc-ui/store/api/types';
import { getAcceptLanguageHeader, resolveAdvertisingApiBaseUrl } from '@urc-ui/store/api/ross/utils';
import { GetTemplatesRequest, GetTemplatesResponse, ListTemplatesResponse } from '@flexible-reports/store/api/templates/api-types';
import { exponentialBackoffWithJitter, getFrbAuthorizationHeaders } from '@flexible-reports/store/api/base';

export const templatesApi = createApi({
  reducerPath: 'templatesApi',
  baseQuery: retry(
    axiosBaseQuery({
      baseUrl: resolveAdvertisingApiBaseUrl()
    }),
    exponentialBackoffWithJitter({ baseDelay: 50, maxDelay: 5000, maxRetries: 5 })
  ),
  tagTypes: [Tag.TEMPLATES],
  endpoints: builder => ({
    listTemplates: builder.query<ListTemplatesResponse, void>({
      query: () => {
        return {
          url: '/adsApi/v1/templates',
          method: HttpMethod.GET,
          headers: { ...getFrbAuthorizationHeaders(), ...getAcceptLanguageHeader() }
        };
      },
      transformResponse: (response: ListTemplatesResponse) => response,
      providesTags: [Tag.TEMPLATES]
    }),
    getTemplates: builder.query({
      query: (request: GetTemplatesRequest) => {
        return {
          url: '/adsApi/v1/retrieve/templates',
          method: HttpMethod.POST,
          data: request,
          headers: { ...getFrbAuthorizationHeaders(), ...getAcceptLanguageHeader() }
        };
      },
      transformResponse: (response: GetTemplatesResponse) => response,
      providesTags: [Tag.TEMPLATES]
    })
  })
});

export const { useListTemplatesQuery, useGetTemplatesQuery } = templatesApi;
